export interface SseFrame {
  event: string;
  data: string;
  id?: string;
}
export interface SseParseResult {
  frames: SseFrame[];
  rest: string;
}
export function parseSseChunk(buffer: string): SseParseResult {
  const normalized = buffer.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const blocks = normalized.split('\n\n');
  const rest = blocks.pop() ?? '';
  const frames: SseFrame[] = [];
  for (const block of blocks) {
    const frame = parseBlock(block);
    if (frame) {
      frames.push(frame);
    }
  }
  return { frames, rest };
}
function parseBlock(block: string): SseFrame | null {
  let event = 'message';
  let id: string | undefined;
  const dataLines: string[] = [];
  let sawField = false;
  for (const line of block.split('\n')) {
    if (line === '' || line.startsWith(':')) {
      continue;
    }
    const colon = line.indexOf(':');
    const field = colon === -1 ? line : line.slice(0, colon);
    let value = colon === -1 ? '' : line.slice(colon + 1);
    if (value.startsWith(' ')) {
      value = value.slice(1);
    }
    switch (field) {
      case 'event':
        event = value;
        sawField = true;
        break;
      case 'data':
        dataLines.push(value);
        sawField = true;
        break;
      case 'id':
        id = value;
        sawField = true;
        break;
      default:
        break;
    }
  }
  if (!sawField) {
    return null;
  }
  return { event, data: dataLines.join('\n'), id };
}
